import type { StaffHomeTrends } from "@lafayette/schemas";
import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { AsyncState } from "../ui/async-state";
import { StatTiles } from "./StatTiles";
import { tileModels } from "./trends";

// The node for the `stats` slot of `HomeLayout` (CHT-2025). `null` while the numbers load, when no tile is offered to the role and when the
// page has no trends reader: the layout then draws no gap and the dark card spans the row. A failed read draws one plain message with a retry
// in the slot, never a tile with an invented number.

export function statsSlot(query: UseQueryResult<StaffHomeTrends>): ReactNode {
  if (query.isError) {
    return (
      <AsyncState
        kind="error"
        title="The numbers could not be loaded"
        message="The staff API did not answer. The rest of Home is still up to date."
        onRetry={() => void query.refetch()}
      />
    );
  }
  if (query.data === undefined) return null;
  const models = tileModels(query.data);
  return models.length === 0 ? null : <StatTiles models={models} />;
}
